import { render, staticRenderFns } from "./highList.vue?vue&type=template&id=3283324c&scoped=true&"
import script from "./highList.vue?vue&type=script&lang=js&"
export * from "./highList.vue?vue&type=script&lang=js&"
import style0 from "./highList.vue?vue&type=style&index=0&id=3283324c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3283324c",
  null
  
)

export default component.exports